import { createContext, useContext, useMemo, useState } from "react";
import LoaderUI from "../Reuse/UI/Loader";

const TabContext = createContext();

export const TabProvider = ({ children,value }) => {

  return (
    <TabContext.Provider value={value}>
      {children}
    </TabContext.Provider>
  );
};

export const useTabFilter = () => {
  return useContext(TabContext);
};
